import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";

/**
 * `createDirectoryCommand` is the command used to create a new directory.
 * `createDirectoryCommand` is always active as it does not depend
 * on the current selection.
 */
export default class CreateDirectoryCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._directoryName = "";
	}

	directoryName() {
		return this._directoryName;
	}

	setDirectoryName(newValue) {
		this._directoryName = newValue;
	}

	accept(aVisitor) {
		return aVisitor.visitCreateDirectoryCommand(this);
	}

	requireRefresh() {
		return true;
	}

	heading() {
		return getNamedCommandHeading("Folder");
	}

	priority() {
		return 1;
	}

	_performOnService(callback) {
		this._documentService.executeCreateDirectoryCommand(this, callback);
	}

	_execute() {
		// Creating folders is only supported on the server-side
		// as we need the ID provided by the server after the
		// folder creation
		// Todo: discuss it with Henrik
	}

	static isApplicable() {
		return true;
	}
}
